<div *ngFor="let i of [1,2,3,4,5]" class="wccard mb-4 p-3 border-bottom">
  <!-- Header Row -->
  <div class="d-flex justify-content-between align-items-start mb-3">
    <div class="d-flex align-items-center gap-3">
      <div class="shimmer shimmer-avatar"></div>
      <div>
        <div class="shimmer shimmer-line mb-2"></div>
        <div class="shimmer shimmer-line"></div>
      </div>
    </div>

    <div class="d-flex gap-2">
      <div class="shimmer shimmer-pill-listing w-50"></div>
      <div class="shimmer shimmer-pill-listing w-50"></div>
    </div>
  </div>

  <!-- First Row of tags/pills -->
  <div class="row mb-2">
    <div class="col-3" *ngFor="let tag of [1,2,3,4,5,6]">
      <div class="shimmer shimmer-pill-listing mb-2"></div>
    </div>
  </div>

  <!-- Second Row of tags/pills -->
  <div class="row">
    <div class="col-3" *ngFor="let tag of [1,2,3,4,5,6]">
      <div class="shimmer shimmer-pill-listing mb-2"></div>
    </div>
  </div>
</div>
